function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-12.1 -418.1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.8,3.35A3.352,3.352,0,0,0,23.451,0H3.35A3.352,3.352,0,0,0,0,3.35v20.1A3.352,3.352,0,0,0,3.35,26.8h20.1a3.352,3.352,0,0,0,3.35-3.35Z",
  transform: "translate(12.1 418.1)",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.021 420.941)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4.489,
  height: 13.503,
  transform: "translate(0.265 6.511)",
  fill: "#2867b2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.539,54.28a2.34,2.34,0,1,0-.059,4.666h.029a2.34,2.34,0,1,0,.03-4.666Z",
  transform: "translate(-56 -54.28)",
  fill: "#2867b2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.8,172.6a4.458,4.458,0,0,0-4.045,2.229v-1.912h-4.488c.06,1.267,0,13.5,0,13.5h4.488V178.88a3.068,3.068,0,0,1,.148-1.1,2.456,2.456,0,0,1,2.3-1.641c1.623,0,2.274,1.239,2.274,3.053v7.225h4.488v-7.743C207.965,174.53,205.75,172.6,202.8,172.6Z",
  transform: "translate(-187.027 -166.407)",
  fill: "#2867b2"
})));

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.801,
    height: 26.801,
    viewBox: "0 0 26.801 26.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/LinkedinLogo.8b92a17f.svg";
export { ForwardRef as ReactComponent };